import React from 'react';
import { useParams } from 'react-router-dom';
import useProjectDetails from '../../hook/useProjectDetails'
import FocusButton from '../Shared/FocusButton';

const ProjectDetails = () => {
    const { projectId } = useParams();

    const [project, setProject] = useProjectDetails(projectId)
    console.log(project);
    return (
        <div className="p-10">
            <div class="card w-full bg-base-100 shadow-xl">
                <div class="carousel w-full">
                    <div id="slide1" class="carousel-item relative w-full">
                        <img src={project.picture} class="w-full" />
                        <div class="absolute flex justify-between transform -translate-y-1/2 left-5 right-5 top-1/2">
                            <a href="#slide4" class="btn btn-circle">❮</a>
                            <a href="#slide2" class="btn btn-circle">❯</a>
                        </div>
                    </div>
                    <div id="slide2" class="carousel-item relative w-full">
                        <img src={project.picture - 2} class="w-full" />
                        <div class="absolute flex justify-between transform -translate-y-1/2 left-5 right-5 top-1/2">
                            <a href="#slide1" class="btn btn-circle">❮</a>
                            <a href="#slide3" class="btn btn-circle">❯</a>
                        </div>
                    </div>
                    <div id="slide3" class="carousel-item relative w-full">
                        <img src={project.picture - 3} class="w-full" />
                        <div class="absolute flex justify-between transform -translate-y-1/2 left-5 right-5 top-1/2">
                            <a href="#slide2" class="btn btn-circle">❮</a>
                            <a href="#slide4" class="btn btn-circle">❯</a>
                        </div>
                    </div>
                </div>
                <div class="card-body">
                    <h2 class="card-title">{project.name}</h2>
                    <div className='flex flex-col justify-evenly lg:flex-row'>
                        <div class="card-actions  py-4">
                            <button class="btn btn-secondary font-bold text-white">
                                <a href={project.live_site}>Live Site</a>
                            </button>
                        </div>

                        <div class="card-actions py-4">
                            <FocusButton>
                                <a href={project.code_link}>Client Code</a>
                            </FocusButton>
                        </div>

                        <div class="card-actions py-4">
                            <button class="btn btn-primary font-bold text-white">
                                <a href={project.server_link}>Server Code</a>
                            </button>
                        </div>
                    </div>
                    <p><span className='font-bold'>Description: </span>{project.description}</p>
                    <p><span className='font-bold'>Technology Used: </span>{project.technology}</p>

                </div>
            </div>
        </div>
    );
};

export default ProjectDetails;